

module.exports = __webpack_require__.stylable.create(
    "DropDownCategories1266808962",
    {"classes":{"root":"DropDownCategories1266808962__root","TPADropdownBase":"","dropdown":"Dropdown2735703861__dropdown","title":"DropdownOption1657114002__title","arrowIcon":"DropdownBase2505024104__arrowIcon"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    10,
    "DropDownCategories1266808962",
    null
);
